import React, { useEffect, useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { useApiClient } from "../../contexts/ApiClientContext";
import Pilot from "../../model/Pilot";
import PagedData from "../../model/PagedData";
import APIEndPoints from "../../utils/APIEndPoints";
import SETTINGS from "../../globals";
import AppSections from "../../utils/AppSections";
import Loading from "../common/Loading";
import AppIcons from "../../utils/AppIcons";
import Button from "../common/button/Button";
import ButtonAction from "../common/button/ButtonAction";
import AppSubSections from "../../utils/AppSubSections";
import UserRoles from "../../model/enums/UserRole";
import PilotsListElement from "./PilotsListElement";
import EmbeddingToolInfo from "../../utils/EmbeddingToolInfo";

/*
  Component to manage the display of the existing PILOTS list
*/
function PilotsList() {
  // reference to the AuthManager
  const authManager = useAuth();
  // reference to the navigator
  const navigate = useNavigate();
  // reference to the ApiClient instance
  const apiClient = useApiClient();
  // activities information to be displayed
  const [data, setData] = useState<Pilot[]>([]);
  // manage data loading animation
  const [loading, setLoading] = useState(true);

  // load record data from the server
  useEffect(() => {
    apiClient
      ?.get<PagedData<Pilot[]>>({
        url: APIEndPoints.PILOTS.ALL,
        requiresToken: true,
      })
      .then((data: PagedData<Pilot[]>) => {
        setData(data.items);
      })
      .catch(() => {
        navigate(SETTINGS.get_path({ section: AppSections.SIGN_IN }));
      })
      .finally(() => {
        setLoading(false);
      });
  }, [apiClient, navigate]);

  if (loading) {
    return <Loading />;
  }

  const canEdit =
    !EmbeddingToolInfo.isChemiTool() &&
    (authManager.isAdmin() ||
      authManager.isModerator() ||
      authManager.isSpecialist());

  return (
    <div>
      <div className="list-page-header">
        <div className="list-page-title">
          <h1>
            <span>{AppIcons.PILOT}</span>
            ChemiNova Case Studies
          </h1>
        </div>
        <div>
          {canEdit && (
            <Button
              label="Create case study"
              purpose={ButtonAction.CREATE}
              onClick={() =>
                navigate(
                  SETTINGS.get_path({
                    section: AppSections.PILOTS,
                    subsection: AppSubSections.CREATE,
                  }),
                )
              }
            />
          )}
        </div>
      </div>
      {data?.length === 0 && (
        <div className="list-no-records">
          No records found. Change search parameters and try again.
        </div>
      )}
      {data?.length > 0 &&
        data.map((item) => {
          // check EDIT rights
          const canEdit =
            !EmbeddingToolInfo.isChemiTool() &&
            (item.id_user === authManager.getUserID() ||
              authManager.getUserRole() === UserRoles.ADMIN);

          return (
            <PilotsListElement canEdit={canEdit} data={item} key={item.id} />
          );
        })}
    </div>
  );
}

export default PilotsList;
